import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Определяем начальное состояние как пустой массив строк
const initialState: string[] = [];

// Создаем slice для управления состоянием билетов
export const selectedTicketsSlice = createSlice({
  name: 'selectedTickets',
  initialState,
  reducers: {
    /**
     * Добавляем или убираем один билет
     * @param state - список выбранных
     * @param action - id билета
     */
    toggleTicket: (state, action: PayloadAction<string>) => {
      const ticketId = action.payload;
      const ticketIndex = state.indexOf(ticketId);

      // Если ID билеты уже есть в массиве, удаляем его
      if (ticketIndex !== -1) {
        state.splice(ticketIndex, 1);
      } else {
        // Если ID билета отсутствует, добавляем его в массив
        state.push(ticketId);
      }
    },

    /**
     * Выбираем все билеты
     * @param state - текущий список выбранных билетов
     * @param action - список билетов
     */
    addAll: (state, action: PayloadAction<string[]>) => {
      action.payload.forEach((ticketId) => {
        if (!state.includes(ticketId)) {
          state.push(ticketId);
        }
      });
    },

    /**
     * Убираем переданные билеты из выбранных
     * @param state - текущий список выбранных билетов
     * @param action - список id для удаления
     */
    removeMany: (state, action: PayloadAction<string[]>) => (
      action.payload.forEach((ticketId) => {
        const ticketIndex = state.indexOf(ticketId);
        if (ticketIndex !== -1) {
          state.splice(ticketIndex, 1);
        }
      })
    ),
    /**
     * Очищаем список гостей
     */
    removeAll: () => initialState
  }
});

export const {
  toggleTicket,
  addAll: selectAllTickets,
  removeMany: removeTicketsSelection,
  removeAll: removeAllTickets
} = selectedTicketsSlice.actions;

export default selectedTicketsSlice.reducer;
